import router from '../router';
import api from '../utils/api';

const KNOWN_SCOPES = [
    'facebook:profile', 'facebook:email', 'facebook:registration-date', 'facebook:birth-day', 'facebook:gender', 'facebook:current-city', 'facebook:hometown', 'facebook:relationship-status', 'facebook:family', 'facebook:education', 'facebook:employers', 'facebook:interests', 'facebook:music', 'facebook:books', 'facebook:movies', 'facebook:other', 'facebook:games', 'facebook:networks', 'facebook:apps', 'facebook:pages-admin', 'facebook:address', 'facebook:emails', 'facebook:phones', 'facebook:screen-name', 'facebook:address-book', 'facebook:call-history', 'facebook:sms-history', 'facebook:mms-history',
    'gplus:kind', 'gplus:occupation', 'gplus:birthday', 'gplus:gender', 'gplus:emails', 'gplus:urls', 'gplus:object-type', 'gplus:id', 'gplus:display-name', 'gplus:name', 'gplus:tagline', 'gplus:about-me', 'gplus:relationship-status', 'gplus:url', 'gplus:image', 'gplus:organizations', 'gplus:places-lived', 'gplus:language', 'gplus:age-range', 'gplus:circled-by-countv', 'gplus:verified', 'gplus:cover',
];

export default {
    namespaced: true,
    state: {
        allIntents: [],
        intent: {
            Issuer: undefined,
            Code: undefined,
            ShortDescription: undefined,
            Description: undefined,
            Scopes: undefined,
        },
        scopes: {
            found: [],
            loading: false,
        },
        consents: [],
    },
    getters: {
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        LIST(state, data) {
            state.allIntents = data;
        },
        LIST_CONSENTS(state, data) {
            if (data) {
                state.consents = data;
            } else {
                state.consents = [];
            }
        },
        SET(state, value) {
            if (!value) {
                const organization = this.getters['auth/organisationId'];
                value = {
                    Issuer: organization,
                    Code: undefined,
                    ShortDescription: undefined,
                    Description: undefined,
                    Scopes: [],
                };
            }

            state.intent = value;
        },
        UPDATE_CODE(state, value) {
            state.intent.Code = value;
        },
        UPDATE_SHORT_DESCRIPTION(state, value) {
            state.intent.ShortDescription = value;
        },
        UPDATE_DESCRIPTION(state, value) {
            state.intent.Description = value;
        },
        UPDATE_SCOPES(state, value) {
            state.intent.Scopes = value;
        },
        FOUND_SCOPES(state, value) {
            state.scopes.found = value;
        },
        LOADING_SCOPES(state, value) {
            state.scopes.loading = value;
        },
    },
    /* eslint-disable no-unused-vars */
    actions: {
        LIST_ALL(context) {
            return api.get('/intents')
                .then(response => context.commit('LIST', response.data))
                .catch((error) => {
                    context.commit('LIST', undefined);
                    context.commit('errors/ADD', error, { root: true });
                });
        },
        NEW(context) {
            const organization = this.getters['auth/organisationId'];
            context.commit('SET', {
                Issuer: organization,
                Code: undefined,
                ShortDescription: undefined,
                Description: undefined,
                Scopes: [],
            });
        },
        QUERY_SCOPES(context, value) {
            context.commit('LOADING_SCOPES', true);
            // TODO turn search for scopes into an api call
            return new Promise(resolve => resolve(KNOWN_SCOPES.filter(scope => (scope || '').toLowerCase().indexOf((value || '').toLowerCase()) > -1)))
                .then((result) => {
                    context.commit('FOUND_SCOPES', result);
                    context.commit('LOADING_SCOPES', false);
                })
                .catch((error) => {
                    context.commit('errors/ADD', error, { root: true });
                    context.commit('LOADING_SCOPES', false);
                });
        },
        SAVE(context) {
            const intentToSave = context.state.intent;
            return api.post('/intents', intentToSave)
                .then((response) => {
                    context.commit('SET', response.data);
                    router.push({ path: '/intents' });
                })
                .catch((error) => {
                    context.commit('SET', undefined);
                    context.commit('errors/ADD', error, { root: true });
                });
        },
        LIST_INTENT_CONSENTS(context, { issuer, intent, filter }) {
            return api
                .get(`/${issuer}/intents/${intent}/consents?filter=${filter}`)
                .then(response => context.commit('LIST_CONSENTS', response.data))
                .catch((error) => {
                    context.commit('LIST_CONSENTS', undefined);
                    context.commit('errors/ADD', error, { root: true });
                });
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/intents.js